import { useMemo, useState } from 'react';
import { Button, Input, Popover } from 'antd';
import { SearchOutlined, SmileOutlined } from '@ant-design/icons';

interface EmojiCategory {
  name: string;
  emojis: string[];
}

const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    name: 'Цели и приоритеты',
    emojis: [
      '🎯', '🏆', '🥇', '🥈', '🥉', '⭐', '🌟', '✨', '💫', '🔥',
      '💎', '🚀', '🎖️', '🏅', '📈', '📊', '📉', '🎊', '🎉', '👑',
      '🏁', '🚩', '🎌', '⚡', '☄️', '🌠', '🪅', '🪩', '🧨', '🎆',
    ],
  },
  {
    name: 'Идеи и инициативы',
    emojis: [
      '💡', '🧠', '🔬', '🧪', '🔭', '🧲', '⚗️', '🔮', '🎨', '🖌️',
      '🖼️', '🎭', '🎬', '🎤', '🎧', '🎼', '🎹', '🎸', '🥁', '🪄',
      '📐', '📏', '🧮', '🪬', '🎲', '🧩', '🪀', '🎰', '🎱', '🪕',
    ],
  },
  {
    name: 'Работа и процесс',
    emojis: [
      '📋', '📝', '📄', '📃', '📑', '📎', '📌', '📍', '📁', '📂',
      '🗂️', '🗃️', '🗄️', '📇', '📚', '📖', '📕', '📗', '📘', '📙',
      '💼', '🏢', '🏛️', '🏦', '🗳️', '🗒️', '🗓️', '📅', '📆', '⏰',
      '⏱️', '⏲️', '🕰️', '⌛', '⏳', '📠', '📟', '📞', '☎️', '📱',
      '🖋️', '🖊️', '✒️', '✏️', '🖍️', '📰', '🗞️', '🔖', '🏷️', '🧾',
    ],
  },
  {
    name: 'Команда и коммуникация',
    emojis: [
      '👥', '👤', '🧑‍💻', '🧑‍🔧', '🧑‍🎨', '🧑‍🏫', '🧑‍💼', '🧑‍🚀', '🤝', '👋',
      '🙌', '👏', '💬', '🗨️', '🗯️', '📣', '📢', '📯', '🔔', '🔕',
      '📨', '📩', '📤', '📥', '📧', '✉️', '📮', '💌', '📫', '📪',
      '🧑‍🎓', '🧑‍🔬', '🧑‍⚖️', '🧑‍🚒', '🧑‍🌾', '🧑‍🍳', '🫂', '🤲', '🙏', '👐',
    ],
  },
  {
    name: 'Техника и разработка',
    emojis: [
      '🖥️', '💻', '⌨️', '🖱️', '🖨️', '🖲️', '💾', '💿', '📀', '🎮',
      '🕹️', '🎛️', '🎚️', '📡', '🔌', '🔋', '🪫', '⚙️', '🔧', '🔨',
      '🛠️', '🗜️', '🪛', '🪜', '🧰', '🧲', '🧷', '🧯', '🛡️', '🔐',
      '🌐', '🔗', '📶', '📲', '📳', '🪤', '🪢', '🕸️', '🧬', '🤖',
      '⚛️', '🧪', '🧫', '🧴', '🧵', '🧶', '🔩', '⛓️', '🗝️', '🔑',
    ],
  },
  {
    name: 'Статусы и маркеры',
    emojis: [
      '✅', '☑️', '✔️', '❌', '❎', '⛔', '🚫', '⚠️', '❗', '‼️',
      '❓', '❔', '❕', '🔒', '🔓', '🔏', '🔐', '🔑', '🗝️', '🛑',
      '🟢', '🟡', '🟠', '🔴', '🟣', '🔵', '⚪', '⚫', '🟤', '🟩',
      '🟨', '🟧', '🟥', '🟪', '🟦', '⬜', '⬛', '🔶', '🔷', '🔸',
      '🔹', '🔺', '🔻', '◾', '◽', '▪️', '▫️', '🔳', '🔲', '💠',
    ],
  },
  {
    name: 'Эмоции и настроение',
    emojis: [
      '😀', '😃', '😄', '😁', '😊', '🙂', '🤩', '😎', '🧐', '🤓',
      '😇', '🥳', '🤯', '😴', '🥱', '🤔', '🙃', '😉', '😌', '🤗',
      '😅', '😂', '🥲', '😭', '😢', '😤', '😡', '🥵', '🥶', '🤡',
      '🥹', '🫠', '🫡', '🫢', '🫣', '🤫', '🤭', '😬', '😮', '😯',
    ],
  },
  {
    name: 'Природа и погода',
    emojis: [
      '🌱', '🌿', '🍀', '🌳', '🌲', '🌴', '🌵', '🌾', '🌷', '🌸',
      '🌺', '🌻', '🌼', '🌞', '🌝', '🌚', '🌙', '⭐', '🌟', '✨',
      '🌈', '☀️', '⛅', '☁️', '🌧️', '⛈️', '🌩️', '❄️', '☃️', '🌊',
      '🍃', '🍂', '🍁', '🌬️', '🌪️', '🌫️', '🪨', '🪵', '🌋', '🏔️',
    ],
  },
  {
    name: 'Транспорт и места',
    emojis: [
      '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐',
      '🚚', '🚛', '🚜', '🛵', '🏍️', '🚲', '🛴', '🛹', '✈️', '🚀',
      '🛸', '🚁', '⛵', '🚤', '🚢', '🏠', '🏡', '🏫', '🏭', '🏰',
      '🚆', '🚄', '🚅', '🚇', '🚈', '🚉', '🛤️', '🛣️', '🗺️', '🧭',
    ],
  },
  {
    name: 'Деньги и ценности',
    emojis: [
      '💰', '💵', '💴', '💶', '💷', '🪙', '💳', '🧾', '💸', '🏧',
      '💹', '🪪', '🎁', '🛍️', '🛒', '🏷️', '🎟️', '🎫', '📦', '🧳',
      '💱', '💲', '🤑', '🪜', '⚖️', '🏪', '🏬', '🏤', '🏣', '🏯',
    ],
  },
  {
    name: 'Спорт и активность',
    emojis: [
      '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱',
      '🪀', '🏓', '🏸', '🥊', '🥋', '🥅', '⛳', '🏹', '🎣', '🤿',
      '🎽', '🛷', '⛸️', '🥌', '🎿', '⛷️', '🏂', '🪂', '🏋️', '🤸',
    ],
  },
  {
    name: 'Еда и напитки',
    emojis: [
      '☕', '🍵', '🥤', '🧃', '🧋', '🍶', '🍷', '🍸', '🍹', '🍺',
      '🍎', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🥝', '🍑',
      '🥖', '🥐', '🥨', '🧀', '🥗', '🍕', '🍔', '🍟', '🌭', '🍿',
    ],
  },
  {
    name: 'Животные',
    emojis: [
      '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯',
      '🦁', '🐮', '🐷', '🐵', '🐸', '🐔', '🐧', '🐦', '🦆', '🦅',
      '🦉', '🦇', '🐺', '🐗', '🐴', '🦄', '🐝', '🪲', '🦋', '🐢',
      '🐬', '🐳', '🐋', '🦈', '🐙', '🦑', '🦀', '🐟', '🦞', '🦐',
    ],
  },
];

const ALL_EMOJIS = EMOJI_CATEGORIES.flatMap((c) => c.emojis);

interface EmojiPickerProps {
  value?: string | null;
  onChange?: (emoji: string | null) => void;
  size?: 'small' | 'middle' | 'large';
}

export function EmojiPicker({ value, onChange, size = 'small' }: EmojiPickerProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return EMOJI_CATEGORIES;
    const matched = EMOJI_CATEGORIES
      .map((cat) => ({
        ...cat,
        emojis: cat.name.toLowerCase().includes(q)
          ? cat.emojis
          : cat.emojis.filter((e) => e.includes(q)),
      }))
      .filter((cat) => cat.emojis.length > 0);
    return matched.length > 0 ? matched : [{ name: 'Совпадений нет', emojis: [] }];
  }, [query]);

  const content = (
    <div style={{ width: 360 }}>
      <Input
        size="small"
        prefix={<SearchOutlined style={{ color: '#bbb' }} />}
        placeholder="Поиск по категории…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        allowClear
        style={{ marginBottom: 8 }}
      />
      <div
        style={{
          maxHeight: 360,
          overflowY: 'auto',
          paddingRight: 4,
        }}
      >
        {filtered.map((cat) => (
          <div key={cat.name} style={{ marginBottom: 10 }}>
            <div
              style={{
                fontSize: 11,
                color: '#8c8c8c',
                textTransform: 'uppercase',
                letterSpacing: 0.4,
                marginBottom: 4,
                paddingLeft: 2,
              }}
            >
              {cat.name}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              {cat.emojis.map((emoji) => (
                <button
                  key={emoji}
                  type="button"
                  onClick={() => {
                    onChange?.(emoji);
                    setOpen(false);
                    setQuery('');
                  }}
                  style={{
                    border: 'none',
                    background: value === emoji ? '#e6f4ff' : 'transparent',
                    borderRadius: 4,
                    cursor: 'pointer',
                    fontSize: 20,
                    width: 30,
                    height: 30,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1,
                  }}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      {value && (
        <div style={{ borderTop: '1px solid #f0f0f0', marginTop: 6, paddingTop: 6, textAlign: 'center' }}>
          <Button
            size="small"
            type="link"
            danger
            onClick={() => { onChange?.(null); setOpen(false); setQuery(''); }}
          >
            Убрать иконку
          </Button>
        </div>
      )}
    </div>
  );

  const dim = size === 'large' ? 40 : size === 'middle' ? 36 : 32;
  const fontSize = size === 'large' ? 22 : size === 'middle' ? 20 : 18;

  return (
    <Popover
      content={content}
      trigger="click"
      open={open}
      onOpenChange={(v) => { setOpen(v); if (!v) setQuery(''); }}
      placement="bottomLeft"
      destroyTooltipOnHide
    >
      <Button
        size={size}
        type="text"
        style={{
          fontSize,
          width: dim,
          height: dim,
          padding: 0,
          lineHeight: 1,
          border: '1px dashed #d9d9d9',
          borderRadius: 6,
        }}
      >
        {value || <SmileOutlined style={{ fontSize: 16, color: '#bbb' }} />}
      </Button>
    </Popover>
  );
}

export const DEFAULT_EMOJIS = ALL_EMOJIS;
